import { Controller } from "@hotwired/stimulus";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

// Connects to data-controller="line-chart"
export default class extends Controller {
  static targets = ["canvas"];
  static values = {
    data: Array,
    xaxisLabel: String,
  };

  connect() {
    this.initChart();
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  initChart() {
    const colors = ["#dc3545", "#6c757d"];

    // Transform data for Chart.js
    const datasets = this.dataValue.map((item, index) => {
      const labels = [];
      const data = [];

      // Sort keys by date
      const sortedKeys = Object.keys(item.data).sort(
        (a, b) => new Date(a) - new Date(b)
      );

      sortedKeys.forEach((key) => {
        labels.push(key);
        data.push(item.data[key]);
      });

      return {
        label: item.name,
        data: data,
        backgroundColor: colors[index],
        borderColor: colors[index],
        borderWidth: 1,
        borderRadius: 4,
      };
    });

    // Get labels from first dataset and format them
    const rawLabels = Object.keys(this.dataValue[0]?.data || {}).sort(
      (a, b) => new Date(a) - new Date(b)
    );

    const labels = rawLabels.map((dateStr) => {
      const date = new Date(dateStr);
      return date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
      });
    });

    const config = {
      type: "bar",
      data: {
        labels: labels,
        datasets: datasets,
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false,
          mode: "index",
        },
        plugins: {
          legend: {
            position: "top",
            align: "end",
            labels: {
              usePointStyle: true,
              pointStyle: "circle",
              padding: 20,
              font: {
                size: 12,
              },
            },
          },
          tooltip: {
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            padding: 12,
            cornerRadius: 8,
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: this.xaxisLabelValue || "Date",
            },
            grid: {
              display: false,
            },
          },
          y: {
            title: {
              display: true,
              text: "Number of Events",
            },
            beginAtZero: true,
            grid: {
              borderDash: [5, 5],
              color: "#e7e7e7",
            },
          },
        },
      },
    };

    this.chart = new Chart(this.canvasTarget, config);
  }
}
